"use client";

import { Navigation } from "./Navigation";
import { MobileNavigation } from "./MobileNavigation";
import { useMobile } from "@/hooks/useMobile";

export function SideNavigation() {
  const isMobile = useMobile();

  return (
    <>
      <Navigation
        isAriaHidden={isMobile}
        className="z-50 min-w-60 fixed left-0 md:top-0 bg-zinc-950 shadow-lg md:flex md:flex-col md:items-center py-8 transition-all md:translate-x-0 max-md:hidden"
      />
      <MobileNavigation isAriaHidden={!isMobile} />
    </>
  );
}
